import {Message} from 'element-ui';
import {ElMessageComponent} from 'element-ui/types/message';
import {TranslateResult} from 'vue-i18n';

export interface MessageOptions {}

export default class MessageUtils {
    private static MESSAGES: ElMessageComponent[] = [];
    
    public static clear() {
        MessageUtils.MESSAGES.forEach(instance => instance.close());
        MessageUtils.MESSAGES = [];
    }
    
    public static displaySuccessMessage(message: string, options: MessageOptions = {}): ElMessageComponent {
        const defaultOptions = {
            message,
            showClose: true,
            duration: 1000
        };
        const instance = Message.success(Object.assign({}, defaultOptions, options));
        MessageUtils.MESSAGES.push(instance);
        return instance;
    }
    
    public static displayErrorMessage(message: string | TranslateResult, options: MessageOptions = {}): ElMessageComponent {
        message = message as string;
        const defaultOptions = {
            message,
            showClose: true,
            duration: 0
        };
        const instance = Message.error(Object.assign({}, defaultOptions, options));
        MessageUtils.MESSAGES.push(instance);
        return instance;
    }
}
